<template>
  <div :class="containerClass" role="alert" aria-live="assertive" aria-atomic="true">
    <div class="rs-alert-content">
      <template v-if="!template">
        <span :class="iconClass"></span>
        <div class="rs-alert__text">
          <h4 v-if="message.summary" class="rs-alert__summary">
            {{ message.summary }}
          </h4>
          <div v-if="message.detail" class="rs-alert__detail">
            {{ message.detail }}
          </div>
        </div>
      </template>
      <component v-else :is="template" :message="message" v-bind="message.payload"></component>
      <button class="rs-alert__close" v-if="message.closable !== false" @click="onCloseClick">
        ×
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'RsAlert',
    emits: ['close'],
    props: {
      message: null,
      template: null
    },
    closeTimeout: null,
    mounted() {
      if (this.message.life) {
        this.closeTimeout = setTimeout(() => {
          this.close()
        }, this.message.life)
      }
    },
    methods: {
      close() {
        this.$emit('close', this.message)
      },
      onCloseClick() {
        if (this.closeTimeout) {
          clearTimeout(this.closeTimeout)
        }
        this.close()
      }
    },
    computed: {
      containerClass() {
        return [
          'rs-alert',
          {
            'rs-alert--info': this.message.severity === 'info',
            'rs-alert--warn': this.message.severity === 'warn',
            'rs-alert--error': this.message.severity === 'error',
            'rs-alert--success': this.message.severity === 'success'
          }
        ]
      },
      iconClass() {
        return []
      }
    }
  }
</script>

<style lang="scss" scoped>
  .rs-alert {
    position: relative;
    display: block;
    padding: 10px 20px;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    font-size: 16px;

    &__summary {
      font-size: 18px;
      margin-bottom: 10px;
    }

    &__detail {
      line-height: 1.4;
    }

    &__close {
      position: absolute;
      top: 0;
      right: 5px;
      width: auto;
      height: auto;
      background-color: transparent;
      border: none;
      font-size: 20px;
      cursor: pointer;
      padding: 0;
      color: #000;
      opacity: 0.6;

      &:hover {
        background-color: transparent;
        opacity: 1;
      }

      &:focus {
        background-color: transparent;
        outline: none;
      }
    }

    &--info {
      color: #084298;
      background-color: #cfe2ff;
      border-color: #b6d4fe;
    }

    &--success {
      color: #155724;
      background-color: #d4edda;
      border-color: #c3e6cb;
    }

    &--error {
      color: #721c24;
      background-color: #f8d7da;
      border-color: #f5c6cb;
    }
  }
</style>
